import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { Field, Input, PageHeader } from '@mkcore/ui';
import { AuditList } from '@/features/admin/audit-list';

const search = z.object({
  action: z.string().optional(),
  entityType: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
});

export const Route = createFileRoute('/_app/admin/audit')({ validateSearch: search, component: Audit });

/** Local date (yyyy-mm-dd) at 00:00 Amsterdam as an ISO instant; good enough for a filter boundary. */
const startOfDay = (d?: string) => (d ? new Date(`${d}T00:00:00`).toISOString() : undefined);

function Audit() {
  const { t } = useTranslation();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const set = (patch: Partial<z.infer<typeof search>>) =>
    void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
  return (
    <>
      <PageHeader eyebrow={t('nav.admin')} title={t('audit.title')} description={t('audit.description')} />
      <div className="mb-4 flex flex-wrap gap-3">
        <Field label={t('audit.actionFilter')} className="w-56">
          {(p) => <Input {...p} defaultValue={s.action} placeholder="admin.user.*" onChange={(e) => set({ action: e.target.value || undefined })} />}
        </Field>
        <Field label={t('audit.entityType')} className="w-40">
          {(p) => <Input {...p} defaultValue={s.entityType} placeholder="user" onChange={(e) => set({ entityType: e.target.value || undefined })} />}
        </Field>
        <Field label={t('audit.from')} className="w-44">
          {(p) => <Input {...p} type="date" defaultValue={s.from} onChange={(e) => set({ from: e.target.value || undefined })} />}
        </Field>
        <Field label={t('audit.to')} className="w-44">
          {(p) => <Input {...p} type="date" defaultValue={s.to} onChange={(e) => set({ to: e.target.value || undefined })} />}
        </Field>
      </div>
      <AuditList
        filter={{
          action: s.action,
          entityType: s.entityType,
          from: startOfDay(s.from),
          to: startOfDay(s.to),
        }}
      />
    </>
  );
}
